import React from 'react';
import { Grid, Typography } from '@mui/material';
import { CashOrderForm as Component } from 'features/payment/components/CashOrderForm';
import { Layout } from '../../../features/common/components/Layout';
import makeStyles from '@mui/styles/makeStyles';
import { Container } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(6),
		marginBottom: theme.spacing(4),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'left',
	},
}));

export const CashPaymentPage = (): JSX.Element => {
	const classes = useStyles();

	return (
		<Layout>
			<Container component="main" maxWidth="xs">
				<div className={classes.paper}>
					<Grid item xs={12} display="flex" justifyContent={'center'}>
						<Typography sx={{ mb: 4 }} variant="h6">
							Orden de pago Cash
						</Typography>
					</Grid>
					<Component />
				</div>
			</Container>
		</Layout>
	);
};
